import React from "react";
import styles from "./TooltipGlodal.module.sass";

// Contenedor global de tooltips (el ReactTooltip original se retiró; los props
// de estilo que quedaban sobre el div disparaban warnings de React en consola).
const TooltipGlodal = () => {
  return <div className={styles.tooltipWpapper} />;
};

export default TooltipGlodal;
